// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bds_","importantInfo":"styles_importantInfo__1dlCJ"};